import React, { useState, useContext } from "react";
import { Box } from "@mui/material";
import AuthContext from "../store/AuthContext";
import CustomTabs from "../component/CustomTabs";

import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import AdminUtility from "./AdminUtility";
import AdminDmtSchema from "./AdminDmtSchema";
import AdminPayoutSchema from "./AdminPayoutSchema";
import AdminAepsSchema from "./AdminAepsSchema";
import AdminCardSchema from "./AdminCardSchema";
import AdminBankSchema from "./AdminBankSchema";

import LICScheme from "./LICScheme";
import GasScheme from "./GasScheme";
import AdminUpiSchema from "./AdminUpiSchema";
import AdminQrScheme from "./AdminQrScheme";
import AdminPgScheme from "./AdminPgScheme";
import AdminGasPipeSchema from "./AdminGasPipeSchema";
const AdminSchema = () => {
  const authCtx = useContext(AuthContext);
  const user = authCtx?.user;
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabs = [
    {
      label: "Utility",
      content: <AdminUtility />,
      icon: <AssuredWorkloadIcon />,
    },

    { label: "Dmt", content: <AdminDmtSchema />, icon: <AssignmentIndIcon /> },

    {
      label: "Payout",
      content: <AdminPayoutSchema />,
      icon: <AssignmentIndIcon />,
    },
    { label: "Upi", content: <AdminUpiSchema />, icon: <AssignmentIndIcon /> },
    {
      label: "Aeps",
      content: <AdminAepsSchema />,
      icon: <AssignmentIndIcon />,
    },
    {
      label: "Card",
      content: <AdminCardSchema />,
      icon: <AssignmentIndIcon />,
    },
    { label: "LIC", content: <LICScheme />, icon: <AssuredWorkloadIcon /> },
    { label: "Gas", content: <GasScheme />, icon: <AssuredWorkloadIcon /> },
     { label: "Gas pipes", content: <AdminGasPipeSchema />, icon: <AssuredWorkloadIcon /> },
    { label: "QR", content: <AdminQrScheme />, icon: <AssuredWorkloadIcon /> },
    { label: "PG", content: <AdminPgScheme />, icon: <AssuredWorkloadIcon /> },
    // { label: "Bank Scheme", content: <AdminBankSchema />,icon:<AssignmentIndIcon/> },
    // { label: "Prabhu Transfer", content: <AdminPraBhu  /> },
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <CustomTabs tabs={tabs} value={value} onChange={handleChange} />
    </Box>
  );
};

export default AdminSchema;
